import {IWedEditorCommonBar, OWedEditorCommonBarConfig} from "/@back@/edit/wed/features/commonBar.js";
import {BaseElementAsync, Label, MsgLabel, OMsgLabelInit, OSkinableInit} from "/@back@/commons/basis.js";
import {IWedEdBar, IWedEditor, IWedEditorMain, OWedEditorMainConfig, WedMgr} from "/@back@/edit/wed/wedEditor.js";
import {Action, EButtonUiContext, IActionToggle} from "/@lib@/commons/actions.js";
import {ILastDatasBuilder, JLastDatas, OLastDatasInit} from "/@lib@/commons/lastDatas.js";
import {DOM, JSX} from "/@lib@/commons/xml/dom.js";
import {OWedEditorBoxConfig, WedEditorBox} from "/@back@/edit/wed/wedEditorBox.js";
import {IWedDiffBar, OWedEditorDiffBarConfig, ShowDiffBar} from "/@back@/edit/wed/features/diffBar.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {IActionable} from "/@back@/commons/actionables.js";
import {WSP_L10N} from "/@lib@/wsp/l10n.js";
import {EDrvState, JSrcFields, SRC, srcRef} from "/@lib@/wsp/src.js";
import {IItemUiEnv, ISrcMainCtx} from "/@back@/wsp/views/itemMain.js";
import {DrvDiffAction} from "/@back@/wsp/widgets/wed/itemEditorExt.js";
import {IWspUiEnv, Wsp, WSP} from "/@lib@/wsp/wsp.js";
import {EItemTypeFamily} from "/@lib@/wsp/wspMetaUi.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {WSP_DRF} from "/@lib@/wsp/drf.js";
import {ItemXmlEd} from "/@back@/wsp/views/item/itemXmlEd.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {ShowSearchBar} from "/@back@/edit/wed/features/searchBar.js";
import {OWedEditorErrBarConfig} from "/@back@/edit/wed/features/boxErrBar.js";

/** Config de l'editor dédié à l'affichage du panel de rendu. */
export interface OWedEditorL10nDrvConfig extends OWedEditorMainConfig {
	hidel10nDrvBar?: boolean
	l10nDrvBarEditorInit?: OWedEditorDiffBarConfig & OWedEditorCommonBarConfig & OWedEditorErrBarConfig
}

/** Enrichissements de l'éditor principal pour gérer l'editor . */
export interface IWedEditorL10nDrvBar extends IWedEditorMain {
	/** si "null", la bar ne sera pas créée */
	l10nDrvBar?: L10nDrvBar | null | undefined

	showL10nDrv(show: boolean): Promise<void>
}

export function AgL10nDrvBarEditor(cls: any): any {
	const proto = cls.prototype as IWedEditorL10nDrvBar;

	const superInit = proto.initialize;
	proto.initialize = function (this: IWedEditorL10nDrvBar, config: OWedEditorL10nDrvConfig) {
		superInit.call(this, config);
		if (config.hidel10nDrvBar)
			this.l10nDrvBar = null;
		else {
			this.reg.addToList("actions:wed:commonbar:end", "baseContent", 1, new ShowL10nDrvAction(), 61);
			this.wedMgr.listeners.on("redrawAtEnd", (wedMgr: WedMgr) => {
				const wedL10nDrvBar = this.wedMgr.reg.getUserData("wedL10nDrvBar", false);
				if (wedL10nDrvBar) this.showL10nDrv(true);
			});
		}
		return this;
	};

	proto.showL10nDrv = async function (this: IWedEditorL10nDrvBar & IWedEditorCommonBar, show: boolean) {
		const persist = this.wedMgr.reg.getPersistUserStates();
		if (show) {
			const wspDefProps = (this.reg as IReg<IItemUiEnv>).reg.env.wsp.wspDefProps;
			if (this.l10nDrvBar === null || !WSP_L10N.isL10n(wspDefProps)) {
				// masqué explicitement dans la conf
			} else {
				if (!this.l10nDrvBar) {
					const init = Object.assign({
						lastDatas: this.config.lastDatas && this.config.lastDatas['bsct'],
					}, (this.config as OWedEditorL10nDrvConfig).l10nDrvBarEditorInit) as OWedEditorL10nDrvConfig & OWedEditorBoxConfig & OWedEditorCommonBarConfig & OLastDatasInit;
					this.l10nDrvBar = new L10nDrvBar().initialize({
						reg: this.wedMgr.reg,
						wedMgr: this.wedMgr,
						wedEditorInit: init,
					} as OL10nDrvBarInit);
					await this.l10nDrvBar.initializedAsync;
				}
				DOM.setHidden(this.l10nDrvBar, false);
				if (persist) persist.setUserDatas({"wedL10nDrvBar": true});
				this.barLayout.showBar(this.l10nDrvBar)
			}
		} else if (this.l10nDrvBar) {
			if (DOM.setHidden(this.l10nDrvBar, true))
				this.barLayout.onHideBar(this.l10nDrvBar);
			if (persist) persist.setUserDatas({"wedL10nDrvBar": false});
		}
	};

	if (!proto.initLastDatasHooks) proto.initLastDatasHooks = [];
	proto.initLastDatasHooks.push(function (this: IWedEditorL10nDrvBar, lastDatas: JLastDatas) {
		/*if (lastDatas.bsct) {
			if (this.wedMgr.rootWedlet) {
				return this.showL10nDrv(true);
			} else {
				this.wedMgr.listeners.once("redrawAtEnd", () => this.showL10nDrv(true));
			}
		}*/
	});

	if (!proto.buildLastDatasHooks) proto.buildLastDatasHooks = [];
	proto.buildLastDatasHooks.push(function (this: IWedEditorL10nDrvBar, lastDatas: JLastDatas) {
		if (this.l10nDrvBar && !this.l10nDrvBar.hidden) this.l10nDrvBar.buildLastDatas(lastDatas);
	});

	return cls;
}

const L10NDRVBAR_ID = "l10nDrvBar";

export interface OL10nDrvBarInit extends OSkinableInit {
	reg: IReg<IItemUiEnv>,
	wedMgr: WedMgr,
	wedEditorInit: OWedEditorL10nDrvConfig & OLastDatasInit,
}

class L10nDrvBar extends BaseElementAsync implements CustomElement, IWedEdBar, ILastDatasBuilder {
	//mainEditor: IWedEditorL10nDrvBar;
	protected reg: IReg<IItemUiEnv>
	protected wedMgr: WedMgr
	protected wedEditorInit: OWedEditorL10nDrvConfig & OLastDatasInit

	protected xmlEd?: ItemXmlEd
	protected msg: MsgLabel

	constructor() {
		super();
		this.id = L10NDRVBAR_ID;
	}

	buildLastDatas(parentLastDatas: JLastDatas) {
		(this.xmlEd?.view as WedEditorBox).buildLastDatas(parentLastDatas);
	}

	protected async _initialize(init: OL10nDrvBarInit): Promise<void> {
		this.reg = init.reg;
		this.wedMgr = init.wedMgr;
		this.wedEditorInit = init.wedEditorInit;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);

		//sr.appendChild(<div id="header">Contenu de référence à traduire</div>);
		this.msg = sr.appendChild(<MsgLabel î={{standardMsg: 'loading'} as OMsgLabelInit}/> as MsgLabel);
		this.refreshUi();
	}

	protected async refreshUi(): Promise<void> {
		this.msg.setCustomMsg("Chargement en cours", 'info');
		try {
			if (this.xmlEd) DOM.setHidden(this.xmlEd, true);
			const sr = this.shadowRoot;
			const drvWspCd = WSP_L10N.findDrvWsp(this.reg.env.wsp);
			const drvWsp = drvWspCd ? this.reg.env.place.getWsp(drvWspCd) : null;
			//await drvWsp.waitForAvailable(); à priori inutile
			if (!drvWsp) {
				this.msg.setCustomMsg("Atelier non accessible", 'warning');
				return;
			}

			let srcRef: srcRef = SRC.srcRef(this.reg.env.longDesc);
			const drvLongDesc = this.reg.env.wsp === drvWsp ? this.reg.env.longDesc : await drvWsp.fetchLongDesc(srcRef);

			// Si item local (ie absent de la ref) => pas d'affichage de l'éditeur
			if (drvLongDesc?.drvState.indexOf("created") >= 0) {
				this.msg.setCustomMsg("Item propre à cet atelier : pas de contenu de référence à afficher.", "info");
				return;
			}

			// l'item a t il été validé une premiere fois et est maintenant dans un état dirty ?
			const drvIsDirtyDone = DrvDiffAction.isEnabledForDrvState("special:drv:default:done", drvLongDesc?.drvState);

			const masterWspCd = await WSP_L10N.findMasterWsp(this.reg.env.wsp, this.reg.env.longDesc);
			const masterWsp = masterWspCd ? this.reg.env.place.getWsp(masterWspCd) : null;
			if (!masterWsp) {
				this.msg.setCustomMsg("Atelier du contenu de référence non accessible.", "info");
				return;
			}
			await masterWsp.waitForAvailable(); //utile pour avoir un reg complet

			const masterWspReg: IReg<IWspUiEnv> = REG.createSubReg(masterWsp.reg);

			// Fction de comparaison à exécuter dans le contexte du reg de l'atelier DRV
			if (drvIsDirtyDone) {
				masterWspReg.addToList("wed.diffBar.actions", "l10nDrvDone", 1,
					new L10nDrvDiffAction("drvDone", "special:drv:default:done", "Contenu associé à la dernière traduction achevée", drvLongDesc, drvWspCd, masterWspCd)//
				);
				masterWspReg.addToList("wed.diffBar.actions", "otherItem", 2, null);
				masterWspReg.addToList("wed.diffBar.actions", "histoItem", 2, null);
			}

			const itemType = masterWspReg.env.wsp.wspMetaUi.getItemType(drvLongDesc.itModel);
			const mainView = itemType.getDataSrcMainView(masterWspReg.env as any as ISrcMainCtx);
			const dataEditor = itemType.getEditor(mainView.xmlEditor);

			if (itemType?.getFamily() === EItemTypeFamily.res) {
				//Edition des metas d'un item.
				let targetUri = itemType.getMainXmlSrcUri(drvLongDesc);
				if (SRC.isSrcId(srcRef)) {
					//On est en contexte db hors cas spéciaux (cf srcRefInContext), on tente de récupérer l'id
					srcRef = (await WSP.fetchSrcId(masterWsp, this.reg.env.uiRoot, targetUri, true)) || targetUri;
				} else {
					srcRef = targetUri;
				}
			}

			masterWspReg.addToList("actions:wed:l10nDrvBar:end", "diffBar", 1, ShowDiffBar.SINGLETON, 1);
			masterWspReg.addToList("actions:wed:l10nDrvBar:end", "searchBar", 1, ShowSearchBar.SINGLETON, 1);

			const {ItemXmlEd} = await import("/@back@/wsp/views/item/itemXmlEd.js");
			const edConfig = Object.assign({
				//OWedEditorL10nDrvConfig
				hidel10nDrvBar: true,
				//OWedEditorCommonBarConfig
				//hideCommonBar: true,
				commonBarListActionsStart: "actions:wed:l10nDrvBar:start",
				commonBarListActionsEnd: "actions:wed:l10nDrvBar:end",
				//disableVirtuals: true,
				//OWedEditorDiffBarConfig
				diffBarMode: 'available',
			} as OWedEditorBoxConfig & OWedEditorCommonBarConfig & OWedEditorDiffBarConfig & OLastDatasInit & OWedEditorL10nDrvConfig, this.wedEditorInit);
			edConfig.lastDatasKey = 'bsct';

			if (this.xmlEd) {
				this.xmlEd.closeEditor();
				this.xmlEd.remove();
				this.xmlEd = null;
			}

			this.xmlEd = this.shadowRoot.appendChild(new ItemXmlEd().initialize({
					reg: masterWspReg,
					srcRef,
					datasEditor: {mainWed: dataEditor.mainWed},
					editorConfig: edConfig,
					wedMgrConfig: {
						readOnlyCauses: ["drvBase"],
						noCleanup: true,
						//rootModel: this.wedMgr.config.rootModel,
						//xaRoot: this.wedMgr.config.xaRoot NON! : impossible de faire une correspondance d efaçon fiable avec le contenu source
					},
					noNotifIfReadOnly: true
				})
			);

			this.msg.setCustomMsg(null);
		} catch (e) {
			this.msg.setCustomMsg("Chargement impossible", 'error');
			return ERROR.log(e);
		}
	}
}

customElements.define("wed-l10ndrv-bar", L10nDrvBar);

REG.reg.registerSkin('wed-l10ndrv-bar', 1, /* language=CSS */ `
	:host {
		display: flex;
		flex-direction: column;
	  min-width: 0;
	  min-height: 0;
  }

  #header {
	  border-bottom: 1px solid var(--border-color);
	  color: var(--alt2-color);
	  font-weight: bold;
	  padding: 3px;
  }

  c-msg {
	  text-align: center;
  }

`);

export class ShowL10nDrvAction extends Action<IWedEditor & IWedEditorL10nDrvBar> implements IActionToggle<IWedEditor & IWedEditorL10nDrvBar> {

	constructor() {
		super("l10nDrv");
		this._label = "Contenu de référence à traduire";
		this._icon = "/@skin@/wsp/widgets/wed/l10nDrvBtn.svg";
	}

	isVisible(ctx: IWedEditor & IWedEditorL10nDrvBar) {
		const wspDefProps = (ctx.reg as IReg<IItemUiEnv>).reg.env.wsp.wspDefProps;
		if (!WSP_L10N.isL10n(wspDefProps)) return false;
		if (ctx.l10nDrvBar === null) return false;
		return super.isVisible(ctx);
	}

	/* On laisse actif : la zone affiche un message explicite indiquant qu'il n'y a rien à montrer. Cela permet de pouvoir refermer la zone
	isEnabled(ctx: IWedEditor & IWedEditorL10nDrvBar): boolean {
		const ld = (ctx.reg as IReg<IItemUiEnv>).reg.env.longDesc;
		if(!ShowL10nDrvAction.drvIsEnabled(ld, (ctx.reg as IReg<IItemUiEnv>).reg.env.wsp)) return false;
		return super.isEnabled(ctx);
	}
	 */

	static drvIsEnabled(ld: JSrcFields, wsp: Wsp) {
		const drvStateField = WSP_DRF.isDrf(wsp.wspDefProps) ? "!ref_drvState" : "drvState";
		if (!(ld as any)[drvStateField] || (ld as any)[drvStateField].indexOf("created") >= 0) return false;
	}

	isToggle(): this is IActionToggle<IWedEditor & IWedEditorL10nDrvBar> {return true}

	getDatas(api: 'toggle', ctx: IWedEditor & IWedEditorL10nDrvBar): boolean | null {
		return ctx.l10nDrvBar != null && !ctx.l10nDrvBar.hidden;
	}

	execute(ctx: IWedEditor & IWedEditorL10nDrvBar, ev?: Event): Promise<any | 'noPreventDefault'> {
		return ctx.showL10nDrv(!ctx.l10nDrvBar || ctx.l10nDrvBar.hidden);
	}

}

export class L10nDrvDiffAction extends DrvDiffAction {

	constructor(id: string, public readonly specialRef: string, label: string, public readonly drvItemLongDesc: JSrcFields, public readonly specialCandidateWspCd?: string, public readonly specialBaseWspCd?: string) {
		super(id, specialRef, label, specialCandidateWspCd, specialBaseWspCd);
	}

	protected drvState(ctx: IWedDiffBar): EDrvState | undefined {
		return this.drvItemLongDesc?.drvState;
	}

}

// Titre de la zone
REG.reg.addToList("actions:wed:l10nDrvBar:start", "l10n", 1, new Action()
		.setGroup("label")
		.override('buildCustomButton', function (this: Action, ctx: {}, uiContext: EButtonUiContext, parent?: Element) {
			const btn = <Label class="label" label="Contenu de référence à traduire" ellipsis="true" skinOver="wed-l10n-base-btn"/>;
			(btn as any as IActionable<any>).action = this;
			(btn as any as IActionable<any>).disabled = true;
			return btn
		})
	, 0);
REG.reg.registerSkin('wed-l10n-base-btn', 1, /* language=CSS */ `
	:host {
		align-items: center;
	}

	.label {
		color: var(--alt2-color);
		font-weight: bold;
		vertical-align: middle;
	}
`);